import { createContext, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";

export const MenuContext = createContext();
// 12345678@Abc
export function MenuProvider({ children }) {
  const [menuOpen, setMenuOpen] = useState(false);
  // const navigate = useNavigate();
  // const location = useLocation();

  return (
    <MenuContext.Provider
      value={{
        menuOpen,
        setMenuOpen
      }}
    >
      {children}
    </MenuContext.Provider>
  );
}
